import { render, staticRenderFns } from "./CalendarMonthDays.vue?vue&type=template&id=4a545210&scoped=true&"
import script from "./CalendarMonthDays.vue?vue&type=script&lang=js&"
export * from "./CalendarMonthDays.vue?vue&type=script&lang=js&"
import style0 from "./CalendarMonthDays.vue?vue&type=style&index=0&id=4a545210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a545210",
  null
  
)

export default component.exports